import React from "react";
import { Menu, MenuItem, MenuButton, SubMenu } from "@szhsin/react-menu";
import "@szhsin/react-menu/dist/index.css";
import { IoMdArrowDropdown } from "react-icons/io";

type PaziaMenuAction = {
  label: string;
  icon?: React.ReactNode;
  onClick: () => void;
  subitems?: PaziaMenuAction[];
};
export interface PaziaMenuProps {
  title: string;
  actions: PaziaMenuAction[];
}

export const PaziaMenu = ({ title, actions }: PaziaMenuProps): JSX.Element => {
  return (
    <Menu
      className="bg-white dark:bg-slate-700 rounded-md "
      menuClassName={"dark:bg-slate-700 dark:text-white"}
      menuButton={
        <MenuButton>
          <div className="flex gap-2 items-center cursor-pointer">
            <IoMdArrowDropdown />
            {title}
          </div>
        </MenuButton>
      }
    >
      {actions.map((action) => {
        if (action.subitems) {
          return (
            <SubMenu label={action.label} key={action.label}>
              {action.subitems.map((subitem) => (
                <MenuItem onClick={subitem.onClick}>
                  <div className="flex items-center">
                    {subitem.icon}
                    <span className="ml-2">{subitem.label}</span>
                  </div>
                </MenuItem>
              ))}
            </SubMenu>
          );
        }
        return (
          <MenuItem
            onClick={action.onClick}
            key={action.label}
            className="dark:bg-slate-700 dark:text-white dark:hover:bg-slate-600"
          >
            {action.icon}
            <span className="ml-2">{action.label}</span>
          </MenuItem>
        );
      })}
    </Menu>
  );
};
